/**
 * OurBricks: the start buttons.
 *
 * Any <a data-ob-app="/start"> gets its href rebuilt as
 *   /{lang}/?ob_studio=1&tier=home&utm_source=...
 * on this shop: the studio script catches the click and opens the studio in place; the href is what a click gets
 * before that script has loaded, or in a new tab (the shop then opens the studio from ?ob_studio=1).
 * Attribution parameters are remembered for the browser session, so a visitor who lands
 * from an ad, browses a few pages and then clicks "Start" still carries the ad's UTMs.
 * Optional per-link extras: data-ob-tier="mini|facade|home", data-ob-gift="true",
 * data-ob-occasion="housewarming|first_home|parents_home|christmas|farewell".
 */
(function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid'];
  var STORE = 'ob_attribution';
  var cfg = window.OurBricks || {};

  function readStored() {
    try { return JSON.parse(sessionStorage.getItem(STORE) || '{}'); } catch (e) { return {}; }
  }
  function writeStored(data) {
    try { sessionStorage.setItem(STORE, JSON.stringify(data)); } catch (e) { /* storage blocked: links still work */ }
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var fresh = {};
    KEYS.forEach(function (k) { var v = params.get(k); if (v) fresh[k] = v; });
    // A new campaign click replaces the previous one; otherwise keep what we had.
    var data = Object.keys(fresh).length ? fresh : readStored();
    if (Object.keys(fresh).length) writeStored(fresh);
    return data;
  }

  function buildHref(link, attribution) {
    var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
    var url;
    try { url = new URL(root, window.location.origin); } catch (e) { return null; }
    url.searchParams.set('ob_studio', '1');
    var tier = link.getAttribute('data-ob-tier');
    if (tier) url.searchParams.set('tier', tier);
    if (link.getAttribute('data-ob-gift') === 'true') url.searchParams.set('gift', '1');
    var occasion = link.getAttribute('data-ob-occasion');
    if (occasion) url.searchParams.set('occasion', occasion);
    Object.keys(attribution).forEach(function (k) { url.searchParams.set(k, attribution[k]); });
    return url.toString();
  }

  // Menu links to landing-page sections are stored as "/#ob-tiers" in the admin menu.
  // Keep the visitor's language: on /fr or /en they point to /fr/#ob-tiers etc.
  function localizeSectionLinks(root) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base === '/') return;
    (root || document).querySelectorAll('a[href^="/#"]').forEach(function (link) {
      link.setAttribute('href', base + link.getAttribute('href').slice(1));
    });
  }

  function decorate(root) {
    var attribution = captureAttribution();
    (root || document).querySelectorAll('a[data-ob-app]').forEach(function (link) {
      var href = buildHref(link, attribution);
      if (href) link.href = href;
    });
    localizeSectionLinks(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { decorate(); });
  } else {
    decorate();
  }
  // Section links in the mobile menu drawer ("/#ob-tiers") point to the page we're already on,
  // so the browser never navigates and the drawer stays open with the page scroll-locked.
  // Close the drawer first, wait for Horizon to release the scroll lock, then scroll to the section.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('header-drawer a[href*="#"]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (e) { return; }
    if (url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '') || !url.hash) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    var drawer = link.closest('header-drawer');
    if (!target || !drawer || typeof drawer.close !== 'function') return;

    event.preventDefault();
    drawer.close();

    // Wait until the drawer has fully closed: scroll lock released AND the <details> reset.
    // Horizon returns focus to the menu button at that moment, which would interrupt a scroll
    // started any earlier (it stopped halfway down the page).
    var started = Date.now();
    (function scrollWhenClosed() {
      var busy = document.documentElement.hasAttribute('scroll-lock') || drawer.querySelector('details[open]');
      if (busy && Date.now() - started < 1500) {
        requestAnimationFrame(scrollWhenClosed);
        return;
      }
      requestAnimationFrame(function () {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        // scrollIntoView gets cut short here; scroll the real scroll container explicitly.
        // Horizon scrolls the window on phones and .page-wrapper from 990px up.
        var wrapper = document.querySelector('.page-wrapper');
        var useWrapper = wrapper && getComputedStyle(document.documentElement).overflowY === 'hidden';
        var scroller = useWrapper ? wrapper : window;
        var current = useWrapper ? wrapper.scrollTop : window.scrollY;
        var offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        var top = target.getBoundingClientRect().top + current - offset;
        scroller.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });

        // Lazy images above the target can load during a long scroll and push it down.
        // When scrolling settles, re-measure and correct (up to 3 times).
        var corrections = 0;
        var settle;
        var eventTarget = useWrapper ? wrapper : window;
        function correct() {
          var drift = target.getBoundingClientRect().top - offset;
          if (Math.abs(drift) > 4 && corrections < 3) {
            corrections++;
            scroller.scrollBy({ top: drift, behavior: 'auto' });
          } else {
            eventTarget.removeEventListener('scroll', onScroll);
          }
        }
        function onScroll() {
          clearTimeout(settle);
          settle = setTimeout(correct, 150);
        }
        eventTarget.addEventListener('scroll', onScroll, { passive: true });
        settle = setTimeout(correct, 150);
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', url.hash);
      });
    })();
  });

  // Re-run when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', function (e) { decorate(e.target); });
  window.OurBricks = Object.assign(cfg, { decorateAppLinks: decorate });
})();
